import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getMembersOverTime } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useMembersOverTime = ({ subdomain = getSubdomain(), startDate, endDate, interval, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        ...options,
        queryKey: analyticsKeys.membersOverTime(subdomain, startDate, endDate, interval),
        queryFn: () => getMembersOverTime(subdomain, startDate, endDate, interval),
        staleTime: FiveMinutes,
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
